module.exports = __webpack_public_path__ + "img/design proposal_demo-05.955fd5fc.jpg";